// "Try again" for a read that stopped before it answered (#647).
//
// Every collection and document window (`useCollectionWindow`,
// `useDocumentWindow`) listens here, and one whose read has failed starts
// over when this is called: a fresh listener, and on the store path a fresh
// read of what the device holds. A window that is reading, or has answered,
// ignores it — a retry is not a refresh.
//
// One call for the whole app rather than one per list, because the button
// that calls it is drawn by the shared failed state (`EmptyState`, `Unread`)
// and does not know which provider's list it stands for. The failures it
// answers are almost never one list's alone either: a dropped connection or
// a refused rule stops every listener started in the same moment.

const listeners = new Set();

/** Subscribe to retries; returns the unsubscribe. */
export function onRetryReads(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Ask every failed read to start over. */
export function retryFailedReads() {
  for (const listener of [...listeners]) {
    try {
      listener();
    } catch (err) {
      console.error('[reads] a retry listener threw:', err);
    }
  }
}
